export type VerifiedBotStatus = 'true' | 'false' | 'unknown'

/**
 * Reads the verified-bot flag from the `<meta name="verifiedbot">` tag injected
 * by our edge worker. Returns 'true'/'false' verbatim or 'unknown' if missing.
 */
export function getVerifiedBot(): VerifiedBotStatus {
  const allowedStatuses = ['true', 'false']
  const verifiedbotValue = document
    .querySelector('meta[name="verifiedbot"]')
    ?.getAttribute('content')

  if (
    typeof verifiedbotValue === 'string' &&
    allowedStatuses.includes(verifiedbotValue)
  ) {
    return verifiedbotValue as VerifiedBotStatus
  }

  return 'unknown'
}
